import React, { useState, useEffect } from 'react';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import { D as Drawer } from './Drawer-NMc-EopI.js';
import ForgotPasswordForm from './components/ForgotPasswordForm/index.js';
import LoginForm from './components/LoginForm/index.js';
import RegisterForm from './components/RegisterForm/index.js';
import { RegisterFormType } from './types/index.js';
import './context/index.js';
import './utils/logToSlack.js';
import './animations--PMkOS0j.js';
import 'cookies-next';
import './currency-_kacFJHO.js';
import './language-BHHwgtQp.js';
import { a as LOCAL_STORAGE_ADD_WISHLIST_PRODUCT } from './localStorage-h6SlcHvK.js';
import './payment-a4IKjS7g.js';
import './index-dEXHnASi.js';
import 'notistack';
import useShowNotify from './hooks/useShowNotify.js';
import 'lodash/get';
import './product-_pRduMz7.js';
import './helpers-WYINLSKJ.js';
import 'lodash';
import { validateHCaptchaTokenOnServer } from './utils/captcha.js';
import { M as MyAccount } from './MyAccount-rPL-qE3G.js';
import { w as withProviders } from './withProviders-l3mjYkR2.js';

var ActionType;
(function (ActionType) {
    ActionType["Login"] = "Login";
    ActionType["Register"] = "Register";
    ActionType["ForgotPassword"] = "ForgotPassword";
    ActionType["Account"] = "Account";
})(ActionType || (ActionType = {}));

const AuthSidebar = ({ isOpen, isLogged, initialActionType = ActionType.Login, onLoginSubmitted, onClose, onLogout, }) => {
    const { t: tHeading } = useTranslation('', { keyPrefix: '$common.$headings' });
    const { t: tLabel } = useTranslation('', { keyPrefix: '$common.$labels' });
    const router = useRouter();
    const showNotify = useShowNotify();
    const [actionType, setActionType] = useState(initialActionType);
    const [loginFormValues, setLoginFormValues] = useState(null);
    const onToggleCreateAccount = (loginValues) => {
        setLoginFormValues(loginValues);
        setActionType(ActionType.Register);
    };
    const handleClose = () => {
        // For a guest user clear addWishlistProduct localStorage value after manual closing a Login sidebar
        if (!isLogged) {
            localStorage.removeItem(LOCAL_STORAGE_ADD_WISHLIST_PRODUCT);
        }
        setActionType(ActionType.Login); // reset to login on modal close
        onClose();
    };
    useEffect(() => {
        setActionType(ActionType.Login);
    }, [router.asPath]);
    return (React.createElement(Drawer, { open: isOpen, onClose: handleClose, name: "auth-sidebar" },
        isLogged && (React.createElement(React.Fragment, null,
            React.createElement("h2", { className: "title" }, tLabel('myAccount')),
            React.createElement(MyAccount, { onLogout: onLogout }))),
        actionType === ActionType.Login && !isLogged && (React.createElement(React.Fragment, null,
            React.createElement("h2", { className: "title", dangerouslySetInnerHTML: { __html: tHeading('loginHeading') } }),
            React.createElement(LoginForm, { legend: tHeading('loginHeading'), showCreateAccountButton: true, validateHCaptchaTokenOnServer: validateHCaptchaTokenOnServer, onSubmitted: onLoginSubmitted, onToggleCreateAccount: onToggleCreateAccount, onToggleForgotPassword: () => setActionType(ActionType.ForgotPassword), onShowNotify: showNotify }))),
        actionType === ActionType.Register && !isLogged && (React.createElement(React.Fragment, null,
            React.createElement("h2", { className: "title" }, tLabel('createAccount')),
            React.createElement(RegisterForm, { formType: RegisterFormType.Drawer, loginFormValues: loginFormValues, siteSubscribeCheckbox: true, validateHCaptchaTokenOnServer: validateHCaptchaTokenOnServer, onBack: () => setActionType(ActionType.Login), onSubmitted: () => {
                    onClose();
                    router.reload();
                }, onShowNotify: showNotify }))),
        actionType === ActionType.ForgotPassword && !isLogged && (React.createElement(React.Fragment, null,
            React.createElement("h2", { className: "title" }, tLabel('forgetPWDLink')),
            React.createElement(ForgotPasswordForm, { validateHCaptchaTokenOnServer: validateHCaptchaTokenOnServer, onSubmitCallback: handleClose, onBack: () => setActionType(ActionType.Login), onShowNotify: showNotify })))));
};
var AuthSidebar$1 = withProviders(AuthSidebar, { translation: true });

export { AuthSidebar$1 as A, ActionType as a };
//# sourceMappingURL=AuthSidebar-fmvVmrte.js.map
